import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from "react-router-dom";
import MobileNumberInput from "./pages/MobileNumberInput";
import UserLandingPage from "./pages/UserLandingPage";
import TransactionsPage from "./pages/TransactionsPage";
import VoucherList from "./pages/VoucherList";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLoginPage from "./pages/AdminLoginPage";
import UserLoginPage from "./pages/UserLoginPage";


const SecureRoute = ({ element }) => {
  const { hash } = useParams();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" />;
  }

  return element;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* 🔐 Secured User Routes */}
        <Route path="/" element={<UserLoginPage />} />
        <Route path="/user/:hash" element={<SecureRoute element={<UserLandingPage />} />} />
        <Route path="/user/:hash/transactions" element={<SecureRoute element={<TransactionsPage />} />} />
        <Route path="/user/:hash/vouchers" element={<SecureRoute element={<VoucherList />} />} />

        {/* 🔐 Secured Admin Routes */}
        <Route path="/a/:hash" element={<SecureRoute element={<AdminDashboard />} />} />
        <Route path="/User" element={<UserLoginPage />} />
      </Routes>
    </Router>
  );
}

export default App;






